import { render, staticRenderFns } from "./notification-panel-item.vue?vue&type=template&id=61323619&scoped=true&"
import script from "./notification-panel-item.vue?vue&type=script&lang=js&"
export * from "./notification-panel-item.vue?vue&type=script&lang=js&"
import style0 from "./notification-panel-item.vue?vue&type=style&index=0&id=61323619&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61323619",
  null
  
)

export default component.exports